const SLIDES_TO_SHOW = 1;

/** Mirrors react-multi-carousel clone index mapping (utils/clones.js). */
export function buildCarouselSlideIndexLookup(
	slideCount: number,
): Record<number, number> {
	if (slideCount <= 0) return { 0: 0 };

	if (slideCount > 2 * SLIDES_TO_SHOW) {
		const table: Record<number, number> = {};
		const firstBeginningOfClones = slideCount - 2 * SLIDES_TO_SHOW;
		const firstEndOfClones = slideCount - firstBeginningOfClones;
		let firstCount = firstBeginningOfClones;

		for (let i = 0; i < firstEndOfClones; i++) {
			table[i] = firstCount;
			firstCount++;
		}

		const secondBeginningOfClones = slideCount + firstEndOfClones;
		const secondEndOfClones =
			secondBeginningOfClones +
			Math.min(slideCount, 2 * SLIDES_TO_SHOW);
		let secondCount = 0;

		for (let i = secondBeginningOfClones; i <= secondEndOfClones; i++) {
			table[i] = secondCount;
			secondCount++;
		}

		const originalEnd = secondBeginningOfClones;
		let originalCounter = 0;

		for (let i = firstEndOfClones; i < originalEnd; i++) {
			table[i] = originalCounter;
			originalCounter++;
		}

		return table;
	}

	const table: Record<number, number> = {};
	const totalSlides = 3 * slideCount;
	let count = 0;

	for (let i = 0; i < totalSlides; i++) {
		table[i] = count;
		count++;
		if (count === slideCount) count = 0;
	}

	return table;
}

export function getSlideIndexFromCarousel(
	carouselIndex: number,
	slideCount: number,
	infinite = true,
): number {
	if (slideCount <= 0) return 0;

	if (!infinite) {
		return Math.max(0, Math.min(carouselIndex, slideCount - 1));
	}

	const lookup = buildCarouselSlideIndexLookup(slideCount);
	if (lookup[carouselIndex] !== undefined) {
		return lookup[carouselIndex];
	}

	return ((carouselIndex % slideCount) + slideCount) % slideCount;
}

export function getCarouselIndexForSlide(
	slideIndex: number,
	slideCount: number,
): number {
	const base =
		slideCount > 2 * SLIDES_TO_SHOW ? 2 * SLIDES_TO_SHOW : slideCount;
	return base + slideIndex;
}
